module.exports = __webpack_public_path__ + "img/mx.57baf107.png";